import React from 'react';

const Dashboard = () => (
  <div className="content">
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-md-8 card">
          <div className="header" style={{textAlign:'center'}}>
            <h3>Swera Techno</h3>
          </div>
          <div className="content">
            </div>
        </div> */}
      </div>
    </div>
  </div>
);

export default Dashboard;


// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js